'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var PromiseManager = require('../../core/promiseManager');
var _require = require('../../util/common'),
  callApi = _require.callApi;
Entry.EXPANSION_BLOCK.disasterAlert = {
  name: 'disasterAlert',
  imageName: 'disasterAlert.png',
  title: {
    ko: '재난문자',
    en: 'Disaster alert'
  },
  titleKey: 'template.disaster_alert_title_text',
  description: Lang.Msgs.expansion_disasterAlert_description,
  descriptionKey: 'Msgs.expansion_disasterAlert_description',
  isInitialized: false,
  init: function init() {
    if (this.isInitialized) {
      return;
    }
    Entry.EXPANSION_BLOCK.disasterAlert.isInitialized = true;
  },
  api: '/api/expansionBlock/disasterAlert',
  apiType: '01'
};
var EMERGENCY_CATEGORY_MAP = {
  info: Lang.Blocks.disasterAlertTypeInfo,
  exigency: Lang.Blocks.disasterAlertTypeExigency,
  urgency: Lang.Blocks.disasterAlertTypeUrgency
};
var getDisasterAlert = function getDisasterAlert(params, defaultValue) {
  var now = new Date();
  var hour = now.getHours();
  var day = now.getDay();
  var key = "disasterAlert-".concat(day, "-").concat(hour);
  var promiseManager = new PromiseManager();
  var job = promiseManager
  // eslint-disable-next-line new-cap
  .Promise(function (resolve) {
    callApi(key, {
      url: "".concat(Entry.EXPANSION_BLOCK.disasterAlert.api)
    }).then(function (result) {
      var _items, _items2, _items3;
      if (result) {
        var _result$data;
        var items = (result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.body) || [];
        var category = EMERGENCY_CATEGORY_MAP === null || EMERGENCY_CATEGORY_MAP === void 0 ? void 0 : EMERGENCY_CATEGORY_MAP[params === null || params === void 0 ? void 0 : params.category];
        if (category) {
          items = items.filter(function (item) {
            return item.EMRG_STEP_NM === category;
          });
        }
        switch (params.command) {
          case 'count':
            return resolve(((_items = items) === null || _items === void 0 ? void 0 : _items.length) || defaultValue || 0);
          case 'get':
            var _result = (_items2 = items) === null || _items2 === void 0 || (_items2 = _items2[(params === null || params === void 0 ? void 0 : params.index) - 1]) === null || _items2 === void 0 ? void 0 : _items2[params.option];
            if (!_result) {
              return resolve(defaultValue);
            }
            if ((params === null || params === void 0 ? void 0 : params.option) === 'REG_YMD') {
              return resolve(new Date(_result).toLocaleString());
            }
            return resolve(_result);
          case 'exist':
            return resolve(((_items3 = items) === null || _items3 === void 0 ? void 0 : _items3.length) > 0);
          default:
            return resolve(defaultValue);
        }
      }
      return resolve(defaultValue);
    })["catch"](function () {
      return resolve(defaultValue);
    });
  })["catch"](function () {
    return defaultValue;
  });
  return job;
};
Entry.EXPANSION_BLOCK.disasterAlert.getBlocks = function () {
  // 전체, 안전안내, 긴급재난, 위급재난
  var DisasterAlertCategory = {
    type: 'Dropdown',
    options: [[Lang.Blocks.disasterAlertTypeAll, 'all'], [Lang.Blocks.disasterAlertTypeInfo, 'info'], [Lang.Blocks.disasterAlertTypeExigency, 'exigency'], [Lang.Blocks.disasterAlertTypeUrgency, 'urgency']],
    value: 'all',
    fontSize: 11,
    bgColor: EntryStatic.colorSet.block.darken.EXPANSION,
    arrowColor: EntryStatic.colorSet.common.WHITE
  };
  // 내용, 수신지역, 긴급단계, 재해구분, 생성일시
  var DisasterAlertOptions = {
    type: 'Dropdown',
    options: [[Lang.Blocks.disasterAlertContents, 'MSG_CN'], [Lang.Blocks.disasterAlertRegeion, 'RCPTN_RGN_NM'], [Lang.Blocks.disasterAlertStep, 'EMRG_STEP_NM'], [Lang.Blocks.disasterAlertDisaster, 'DST_SE_NM'], [Lang.Blocks.disasterAlertRegisterDate, 'REG_YMD']],
    value: 'MSG_CN',
    fontSize: 11,
    bgColor: EntryStatic.colorSet.block.darken.EXPANSION,
    arrowColor: EntryStatic.colorSet.common.WHITE
  };
  return {
    disaster_alert_title: {
      template: '%1',
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.template.disaster_alert_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'disaster_alert_title'
      },
      "class": 'disasterAlert',
      isNotFor: ['disasterAlert'],
      events: {}
    },
    count_disaster_alert: {
      color: EntryStatic.colorSet.block["default"].EXPANSION,
      outerLine: EntryStatic.colorSet.block.darken.EXPANSION,
      skeleton: 'basic_string_field',
      statements: [],
      params: [DisasterAlertCategory],
      events: {},
      def: {
        params: [DisasterAlertCategory.value],
        type: 'count_disaster_alert'
      },
      pyHelpDef: {
        params: ['A&value'],
        type: 'count_disaster_alert'
      },
      paramsKeyMap: {
        CATEGORY: 0
      },
      "class": 'disasterAlert',
      isNotFor: ['disasterAlert'],
      func: function func(sprite, script) {
        var category = script.getField('CATEGORY', script);
        return getDisasterAlert({
          command: 'count',
          category: category
        }, 0);
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'disasterAlert'
    },
    get_disaster_alert: {
      color: EntryStatic.colorSet.block["default"].EXPANSION,
      outerLine: EntryStatic.colorSet.block.darken.EXPANSION,
      skeleton: 'basic_string_field',
      statements: [],
      params: [DisasterAlertCategory, {
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }, DisasterAlertOptions],
      events: {},
      def: {
        params: [DisasterAlertCategory.value, 1, DisasterAlertOptions.value],
        type: 'get_disaster_alert'
      },
      pyHelpDef: {
        params: ['A&value', 'B&value', 'C&value'],
        type: 'get_disaster_alert'
      },
      paramsKeyMap: {
        CATEGORY: 0,
        NUMBER: 1,
        OPTION: 2
      },
      "class": 'disasterAlert',
      isNotFor: ['disasterAlert'],
      func: function func(sprite, script) {
        var number = script.getStringValue('NUMBER', script);
        var category = script.getField('CATEGORY', script);
        var option = script.getField('OPTION', script);
        return getDisasterAlert({
          command: 'get',
          category: category,
          index: number,
          option: option
        });
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'disasterAlert'
    },
    check_disaster_alert: {
      color: EntryStatic.colorSet.block["default"].EXPANSION,
      outerLine: EntryStatic.colorSet.block.darken.EXPANSION,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [DisasterAlertCategory],
      events: {},
      def: {
        params: [DisasterAlertCategory.value],
        type: 'check_disaster_alert'
      },
      pyHelpDef: {
        params: ['B&value', null],
        type: 'check_disaster_alert'
      },
      paramsKeyMap: {
        CATEGORY: 0
      },
      "class": 'disasterAlert',
      isNotFor: ['disasterAlert'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var category;
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                category = script.getField('CATEGORY', script);
                return _context.abrupt("return", getDisasterAlert({
                  command: 'exist',
                  category: category
                }));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      syntax: {
        js: [],
        py: []
      },
      wikiClass: 'disasterAlert'
    }
  };
};